import strings from "global/constants/StringConstants";
import { hasAccessTo } from "layouts/Config";

export const RENEWABLE_CONSTANTS = {
  /** `value` is sent to the API as the number of calendar months in the range, including the current month. */
  MONTH_OPTIONS: [
    { label: "3 months", value: 3 },
    { label: "6 months", value: 6 },
    { label: "9 months", value: 9 },
  ],

  /** Shared props for month-range `CustomAutoComplete` (select-style, no clear, wider list). */
  MONTH_AUTOCOMPLETE_PROPS: {
    freeSolo: false as const,
    disableClearable: true,
    componentsProps: {
      paper: {
        sx: { minWidth: 260 },
      },
    },
  },

  TABLE_HEADERS: [
    { name: "File Name", field: "fileName", align: "left" },
    { name: "Signer", field: "signer", align: "left" },
    { name: "Requested By", field: "requestedBy", align: "left" },
    { name: "Created On", field: "createdOn", align: "left" },
    { name: "Termination", field: "terminationDate", align: "left" },
    ...(hasAccessTo(strings.downloadPermission, strings.resources.renewable)
      ? [{ name: "Action", field: "action", align: "center" }]
      : []),
  ],
};
